// extracted by mini-css-extract-plugin
export default {"container":"Message_container__8cP3N","errorButton":"Message_errorButton__VWyvp"};